import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import withStyles from '@material-ui/core/styles/withStyles';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import Typography from '@material-ui/core/Typography/Typography';
import React from 'react';
const NeoToolTipPopup = withStyles((theme) => ({
// tooltip: {
//   backgroundColor: '#f5f5f9',
//   color: 'rgba(0, 0, 0, 0.87)',
//   maxWidth: 240,
//   fontSize: theme.typography.pxToRem(12),
//   border: '1px solid #dadde9',
// },
}))(Tooltip);
export default function NeoToolTip(props) {
    const { children, tip, open, title } = props;
    const { title: titleDefault } = props;
    let show = open;
    if (titleDefault !== undefined) {
        console.log(`title default show=${title}`);
    }
    let head = "", msg = "", tail = "";
    if (tip) {
        head = tip.head;
        msg = tip.msg;
        tail = tip.tail;
    }
    else if (!title) {
        show = false;
    }
    const renderTitle = (title, tip) => {
        if (tip) {
            return (_jsxs(React.Fragment, { children: [_jsx(Typography, Object.assign({ color: "primary" }, { children: _jsxs("b", { children: [" ", head] }) })), _jsx("br", {}), msg, _jsx("br", {}), _jsx("br", {}), _jsx("b", { children: tail })] }));
        }
        else {
            return (_jsx(React.Fragment, { children: title }));
        }
    };
    if (show) {
        return (_jsx(NeoToolTipPopup, Object.assign({ placement: "left", title: renderTitle(title, tip) }, { children: children })));
    }
    return (_jsx(React.Fragment, { children: children }));
}
//# sourceMappingURL=NeoToolTip.js.map